import React from 'react'

import Loading from 'components/base/Loading'

import {
  Container,
  HiddenCheckbox,
  LabelContent,
  VisibleCheckbox,
} from './styles'

import type { Props } from './types'

const Checkbox: React.FC<Props> = ({
  'aria-label': ariaLabel,
  children,
  loading = false,
  name,
  onChange,
  value = false,
}): React.ReactElement => {
  return (loading && <Loading />) || (
    <Container htmlFor={name}>
      <HiddenCheckbox
        id={name}
        aria-label={ariaLabel}
        checked={Boolean(value)}
        onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
          onChange && onChange(event)
        }}
      />
      <VisibleCheckbox isChecked={Boolean(value)} />
      <LabelContent>
        {children}
      </LabelContent>
    </Container>
  )
}

export * from './types'

export default Checkbox
